{
  "pages": [
    {
      "name": "Cold Water Supply System",
      "elements": [
        {
          "type": "panel",
          "name": "panel9",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            },
            {
              "type": "boolean",
              "name": "LeftToRight",
              "title": "Reverse orientation?",
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Cold Water Supply System"
        },
        {
          "type": "panel",
          "name": "panel5",
          "elements": [
            {
              "type": "boolean",
              "name": "Q_SC_present",
              "title": "Flow meter of cold water supply?",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "Q_SC_address",
              "visibleIf": "{Q_SC_present} = true",
              "isRequired": true,
              "title": "Flow meter address",
              "inputType": "number"
            }
          ],
          "title": "Flow Meter"
        }
      ],
      "title": "Cold water supply"
    }
  ]
}